/**
 * @file
 * Karhu Swipetable js.
 */
(function($, Drupal, drupalSettings) {
  "use strict";

  $('.stack-table').stacktable();
})(jQuery, Drupal, drupalSettings);
